import type { SupportedLanguage } from '@/app/types';
import type { EarnActivity } from './_apis';

type LocalizedTextRecord = Partial<Record<SupportedLanguage, string>>;

type LocalizedTextValue =
  | string
  | {
      langs?: LocalizedTextRecord;
    }
  | LocalizedTextRecord
  | null
  | undefined;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const getEarnLocalizedText = (value: unknown, locale: SupportedLanguage = 'en') => {
  if (typeof value === 'string') return value;
  if (!isRecord(value)) return '';

  const source = isRecord(value.langs) ? value.langs : value;
  const candidates: string[] = [locale, 'en', 'zh'];

  for (const key of candidates) {
    const text = source[key];
    if (typeof text === 'string' && text.trim()) return text;
  }

  const fallback = Object.values(source).find((text) => typeof text === 'string' && text.trim());
  return typeof fallback === 'string' ? fallback : '';
};

export const normalizeEarnActivityText = (activity: EarnActivity, locale: SupportedLanguage = 'en'): EarnActivity => ({
  ...activity,
  content: getEarnLocalizedText((activity as { content?: LocalizedTextValue }).content, locale),
  subtitle: getEarnLocalizedText((activity as { subtitle?: LocalizedTextValue }).subtitle, locale),
  title: getEarnLocalizedText((activity as { title?: LocalizedTextValue }).title, locale),
});
